const mainSearchForm = {
  flights: "טיסות", // translated
  tours: "סיורים", // translated
  hotel: "מלון", // translated
  hotels: "בתי מלון", // translated
  services: "שירותים", // translated
  search: "לחפש", // translated
  destination: "יַעַד", // translated
  includedServices: "שירותים כלולים", // translated
  packageDuration: "משך החבילה", // translated
  checkInOut: "צ'ק-אין/אאוט", // translated
  guests: "אורחים", // translated
  adults: "מבוגרים", // translated
  children: "יְלָדִים", // translated
  child: "יֶלֶד", // translated
  age: "גיל", // translated
  yearsOld: "שנים", // translated
  rooms: "חדרים", // translated
  close: "סגור", // translated
  searchType: "סוג חיפוש", // translated
  accommodation: "דִיוּר", // translated
  transfers: "העברות", // translated
  toursExperiences: "סיורים/חוויות", // translated
  nights: "לילות", // translated
  days: "ימים", // translated
  packageType: "סוג האריזה", // translated
  tourType: "סוג סיור", // translated
  packages: "חבילות", // translated
  cars: "מכוניות", // translated
  cruises: "הפלגות", // translated
  infantsInSeat: "תינוקות במושב", // translated
  infantsOnLap: "תינוקות על הברכיים", // translated
  airport: "שדה תעופה", // translated
  passengers: "נוסעים", // translated
  departureReturn: "תאריכי יציאה וחזרה", // translated
  origin: "מָקוֹר", // translated
  roundTrip: "נסיעה הלוך ושוב", // translated
  isRoundTrip: "הוא הלוך ושוב", // translated
  dream_packages: "חבילות חלומות", // translated
  partying: "לחגוג", // translated
  thingsToDo: "דברים לעשות", // translated
};


export default mainSearchForm;
